<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doordevicearea_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-custom"
          @click="openAuthDialog(scope.row)"
          >授权
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="授权"
      append-to-body
      :visible.sync="authFlag"
      width="350px"
      @closed="closedDialog()"
    >
      <template slot-scope="scope">
        <el-tree
          v-loading="flishFlag"
          element-loading-text="加载中"
          class="org-tree"
          :expand-on-click-node="false"
          :data="propertyList"
          :check-on-click-node="true"
          v-show="ishowTree"
          show-checkbox
          ref="tree"
          :check-strictly="true"
          highlight-current
          node-key="key"
          :default-expand-all="true"
          :default-checked-keys="propertyIds"
          @check-change="currentchange"
          @check="handleCheck"
          @node-click="handleNodeClick"
          :props="defaultProps"
        >
        </el-tree>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="authFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDoorInfoByCommunityId,
  getBasePropertyTree,
  auth,
  getAuthInfo,
} from '@/api/v4ward/door/devicearea/doordevicearea';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      searchOrgId: '',
      input: [],
      ishowTree: false,
      propertyList: [],
      propertyIds: '',
      flishFlag: true,
      defaultProps: {
        label: 'objectFullName',
        value: 'value',
        children: 'children',
      },
      organCodes: [],
      projectOrg: '',
      restaurants: [],
      state: '',
      doorBaseInfoList: [],
      query: {},
      authFlag: false,
      doordeviceareaIdTemp: '',
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        align: 'center',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 110,
        columnBtn: false,
        dialogWidth: '30%',
        span: 24,
        column: [
          {
            label: '小区名称',
            prop: 'communityName',
            display: false,
            rules: [
              {
                required: true,
                message: '请输入小区名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityId',
            dataType: 'string',
            type: 'tree',
            search: true,
            hide: true,
            editDisabled: true,
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            dicUrl: '/api/door/baseinfo/getCommunityFromDoorInfo',
            rules: [
              {
                required: true,
                message: '小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '门禁名称',
            prop: 'doorName',
            display: false,
          },
          {
            label: '门禁名称',
            prop: 'baseInfoId',
            type: 'tree',
            dataType: 'number',
            hide: true,
            columnBtn: false,
            dicData: [],
            props: {
              label: 'doorInfoName',
              value: 'doorInfoId',
            },
            rules: [
              {
                required: true,
                message: '请选择门禁名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '门禁品牌',
            prop: 'doorDeviceBrand',
            type: 'tree',
            placeholder: ' ',
            dicUrl: '/api/blade-system/dict/dictionary?code=door_device_brand',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            disabled: true,
          },
          {
            label: '区域名称',
            prop: 'areaName',
            rules: [
              {
                required: true,
                message: '请输入区域名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域id',
            prop: 'areaId',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doordevicearea_add, true),
        viewBtn: this.vaildData(this.permission.doordevicearea_view, false),
        delBtn: this.vaildData(this.permission.doordevicearea_delete, false),
        editBtn: this.vaildData(this.permission.doordevicearea_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    //联动填充门禁名称
    'form.communityId'(val) {
      this.form.baseInfoId = '';
      const column = this.findObject(this.option.column, 'baseInfoId');
      if (val != null && val != undefined && val != '') {
        getDoorInfoByCommunityId(val).then((res) => {
          this.doorBaseInfoList = res.data;
          column.dicData = res.data;
        });
      } else {
        this.doorBaseInfoList = [];
        column.dicData = [];
      }
    },
    //联动填充品牌
    'form.baseInfoId'() {
      let doorList = this.doorBaseInfoList;
      let doorBaseInfoId = this.form.baseInfoId;
      for (let i = 0; i < doorList.length; i++) {
        if (doorList[i].doorInfoId == doorBaseInfoId) {
          this.form.doorDeviceBrand = doorList[i].brand;
        } else {
          this.form.doorDeviceBrand = '';
        }
      }
    },
  },
  methods: {
    submitAuth() {
      var propertyIds = this.propertyIds.toString();
      auth({
        doorDeviceAreaId: this.doordeviceareaIdTemp,
        autType: 1,
        propertyIds: propertyIds,
      }).then(() => {
        this.authFlag = false;
        this.$message({
          type: 'success',
          message: '操作成功!',
        });
        this.onLoad();
      });
    },
    getCheckNodeDown(tmpKey, currentKey) {
      let parentId = this.$refs.tree.getNode(tmpKey).data.parentId;
      let nodeInfo = this.$refs.tree.getNode(tmpKey);
      if (parentId == 0) {
        return true;
      }
      if (this.$refs.tree.getNode(parentId).checked) {
        this.$refs.tree.getNode(currentKey).checked = false;
        this.$message.warning('对父节点授权时，无需选择子节点');
        return false;
      }
      this.getCheckNodeDown(parentId, currentKey);
    },
    getCheckNodeUp(childNodes, tmpKey, currentKey) {
      childNodes =
        this.$refs.tree.getNode(tmpKey).childNodes.length > 0
          ? this.$refs.tree.getNode(tmpKey).childNodes
          : [];
      if (childNodes.length == 0) {
        return;
      }
      for (let item of childNodes) {
        if (item.checked) {
          this.$refs.tree.getNode(currentKey).checked = false;
          this.$message.warning('对子节点授权时，无需选择父节点');
        } else if (item.childNodes.length > 0) {
          this.getCheckNodeUp(item.childNodes, item.data.key, currentKey);
        }
      }
    },
    handleCheck(data, nodes, e) {
      let key = data.key;
      let result = this.getCheckNodeDown(key, key);
      let result_ = this.getCheckNodeUp([], key, key);

      let self = this;
      self.$nextTick(() => {
        let nodesList = self.$refs.tree.getCheckedKeys();
        self.propertyIds = nodesList.join(',');
      });
    },
    //树型点击
    projectOrgFalse() {
      this.ishowTree = false;
    },
    handleNodeClick(data, node, com) {},
    getOrgList(node, resolve) {
      let that = this;
      //等于0表示根节点
      if (node.level == 0) {
        resolve(FirstRootNodeData);
        //直接返回
        return;
      } else {
        resolve(LeafNodeData);
        return;
      }
    },
    projectOrgFun(e) {
      let that = this;
      if (this.ishowTree) {
        this.ishowTree = false;
      } else {
        this.ishowTree = true;
      } //第一种方式:点击其他区域, 消失树

      document.onclick = function () {
        that.ishowTree = false;
      };
      e.stopPropagation(); //阻止冒泡 //离开区域的时候树消失
      // that.$refs.tree.$el.onmouseleave = function () {
      //     that.ishowTree = false;
      // }

      // that.$refs.treeParent.$el.onmouseleave = function () {
      //     that.ishowTree = false;
      // }
    },
    openAuthDialog(row) {
      //先清空数据
      this.doordeviceareaIdTemp = '';
      this.propertyIds = [];
      this.authFlag = true;
      this.ishowTree = true;
      this.doordeviceareaIdTemp = row.id;
      let communityId = row.communityId;
      getBasePropertyTree(communityId).then((res) => {
        this.propertyList = res.data;
        this.flishFlag = false;
      });
      getAuthInfo({ id: row.id, authType: '1' }).then((res) => {
        this.propertyIds = res.data;
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    closedDialog() {
      this.propertyList = [];
      this.flishFlag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tree {
  cursor: default;
  background: #fff;
  color: #606266;
  z-index: 100;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}
.org-tree {
  height: 450px;
  overflow: auto;
}
</style>
